import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/nav/share/page',
    method: 'get',
    params
  })
}

export function getById(id) {
  return request({
    url: `/nav/share/getById/${id}`,
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'nav/share/',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/nav/share/',
    method: 'put',
    data
  })
}

export function remove(ids) {
  return request({
    url: `/nav/share/delete/${ids}`,
    method: 'delete'
  })
}
